module.exports = __webpack_public_path__ + "img/feature-1.0eea9b38.jpg";